<div class="modal-content">
  <div class="modal-header">
    <h6 class="modal-title" id="modal-title-default" [translate]="'REGULAMENTO_TITULO_INDICACAO'"></h6>
    <button id="btn-fechar-modal-regulamento-indicacao" type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="modal.close()">
      <i class="mdi mdi-close"></i>
    </button>
  </div>
  <div class="modal-body">
    <div>
      <p><strong><span [innerHTML]="'REG_IND_REGRAS_GERAIS' | translate"></span></strong></p>

      <p><strong><span [innerHTML]="'REG_IND_1_TIT' | translate"></span></strong></p>
      <ul>
        <li><span [innerHTML]="'REG_IND_1_ITEM1' | translate"></span></li>
      </ul>

      <p><strong><span [innerHTML]="'REG_IND_2_TIT' | translate"></span></strong></p>
      <ul>
        <li><span [innerHTML]="'REG_IND_2_ITEM1' | translate"></span></li>
      </ul>

      <p><strong><span [innerHTML]="'REG_IND_3_TIT' | translate"></span></strong></p>
      <ul>
        <li><span [innerHTML]="'REG_IND_3_ITEM1' | translate"></span></li>
        <li><span [innerHTML]="'REG_IND_3_ITEM2' | translate"></span></li>
        <li><span [innerHTML]="'REG_IND_3_ITEM3' | translate"></span></li>
      </ul>

      <p><strong><span [innerHTML]="'REG_IND_4_TIT' | translate"></span></strong></p>
      <ul>
        <li><span [innerHTML]="'REG_IND_4_ITEM1' | translate"></span></li>
        <ul>
          <li><span [innerHTML]="'REG_IND_4_SUBITEM1' | translate"></span></li>
          <li><span [innerHTML]="'REG_IND_4_SUBITEM2' | translate"></span></li>
        </ul>
      </ul>

      <p><strong><span [innerHTML]="'REG_IND_5_TIT' | translate"></span></strong></p>
      <ul>
        <li><span [innerHTML]="'REG_IND_5_ITEM1' | translate"></span></li>
      </ul>

      <p><strong><span [innerHTML]="'REG_IND_6_TIT' | translate"></span></strong></p>
      <ul>
        <li><span [innerHTML]="'REG_IND_6_ITEM1' | translate"></span></li>
      </ul>

      <p style="color: #e53935;"><span [innerHTML]="'REG_IND_OBS' | translate"></span></p>
    </div>
  </div>
  <div class="modal-footer">
    <button *ngIf="!modoConfirmacao" type="button" class="btn btn-primary" (click)="modal.close()">OK</button>
    <div *ngIf="modoConfirmacao" class="d-flex gap-2">
      <button type="button" class="btn btn-secondary" (click)="modal.dismiss('cancelar')">{{ 'CANCELAR' | translate }}</button>
      <button type="button" class="btn btn-primary" (click)="modal.close('aceito')">{{ 'ACEITO_OS_TERMOS' | translate }}</button>
    </div>
  </div>
</div>


